import { Banner } from '@/components/Banner/Banner';
import type { Bundle } from '@/components/Store.d';
import { languageStrings } from '@/l18n/de';
import { getPurUrl } from '@/lib/banner';
import { setInnerHTML } from '@/lib/util';

type Props = {
	bundle: Bundle | null;
};

const BannerNotQualified = ({ bundle }: Props) => {
	const ctaUrl = getPurUrl(bundle);

	return (
		<Banner className="banner-warning">
			<div className="banner--active-hint">
				<strong>{languageStrings.notQualifiedForCheaperPur.heading}</strong>
				<span dangerouslySetInnerHTML={setInnerHTML(languageStrings.notQualifiedForCheaperPur.explanation(ctaUrl))}></span>
			</div>
		</Banner>
	);
};

export { BannerNotQualified };
